import React, { useEffect, useState } from "react";
import "../styling/OurApps.css";

const files = {
  voeta: {
    apk_64: "downloads/voeta_64bit.apk",
    apk_32: "downloads/voeta_32bit.apk",
    apk_universal: "downloads/voeta_universal.apk",
    ipa: "downloads/voeta.ipa",
  },
  voetamoney: {
    apk_64: "downloads/voetamoney_64bit.apk",
    apk_32: "downloads/voetamoney_32bit.apk",
    apk_universal: "downloads/voetamoney_universal.apk",
    ipa: "downloads/voetamoney.ipa",
  },
};

const OurApps = () => {
  const [buttons, setButtons] = useState({
    voeta: null,
    voetamoney: null,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isDesktop = !isIOS && !isAndroid;
    const is64Bit = /arm64|aarch64|x86_64/i.test(userAgent);

    const checkFileExists = async (url) => {
      try {
        const response = await fetch(url, { method: "HEAD" });
        return response.ok;
      } catch {
        return false;
      }
    };

    const renderDownload = async (appKey, appName) => {
      const appFiles = files[appKey];

      if (isIOS) {
        const exists = await checkFileExists(appFiles.ipa);
        return exists
          ? <a className="button" href={appFiles.ipa}>Download for iOS (.ipa)</a>
          : <span className="unavailable">{appName} for iOS is currently unavailable.</span>;
      }

      if (isAndroid) {
        const archKey = is64Bit ? "apk_64" : "apk_32";
        const archName = is64Bit ? "64-bit" : "32-bit";
        const specificUrl = appFiles[archKey];
        const universalUrl = appFiles.apk_universal;

        const specificExists = await checkFileExists(specificUrl);
        if (specificExists) {
          return <a className="button" href={specificUrl}>Download Android {archName} APK</a>;
        }

        const universalExists = await checkFileExists(universalUrl);
        if (universalExists) {
          return <a className="button" href={universalUrl}>Download Universal APK</a>;
        }

        return <span className="unavailable">No APK available for Android {archName} devices.</span>;
      }

      if (isDesktop) {
        return <span className="unavailable">Please open this page on an Android or iOS device to download the app.</span>;
      }

      return null;
    };

    const loadAll = async () => {
      const voetaBtn = await renderDownload("voeta", "VOETA");
      const voetamoneyBtn = await renderDownload("voetamoney", "VOETA MONEY");
      setButtons({ voeta: voetaBtn, voetamoney: voetamoneyBtn });
    };

    loadAll();
  }, []);

  return (
    <div className="dep-card">
      <h1>Download VOETA Apps</h1>

      <div className="section" id="voeta-section">
        <h2>VOETA App</h2>
        <div className="buttons">{buttons.voeta}</div>
      </div>

      <div className="section" id="voetamoney-section">
        <h2>VOETA MONEY App</h2>
        <div className="buttons">{buttons.voetamoney}</div>
      </div>

      {/* Optional Language Switcher */}
      <div className="gtranslate_wrapper"></div>
      <script>
        {`
        window.gtranslateSettings = {
          default_language: "en",
          native_language_names: true,
          languages: ["en", "fr"],
          wrapper_selector: ".gtranslate_wrapper",
          alt_flags: { "en": "usa" }
        };
        `}
      </script>
      <script
        src="https://cdn.gtranslate.net/widgets/latest/float.js"
        defer
      ></script>
    </div>
  );
};

export default OurApps;
